import CartFlexed from "../layouts/cart/CartFlexed";
import { removeDuplicate } from "../utils/remove-duplicate/removeDuplicate";
import CartContentArea from "../layouts/cart/CartContentArea";
import CartAside from "../layouts/cart/CartAside";
import CartIndividual from "../components/cart/CartIndividual";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";
import Empty from "../components/empty-state/Empty";
import useAuth from "../hooks/useAuth";

const Cart = () => {
  const { cart } = useAuth();
  const carts = removeDuplicate(cart, (i) => i.product.product_name);
  const cartIsEmpty = carts.length < 1;

  let sum = 0;

  cart.forEach((element) => {
    sum += Number(element.product.product_prices[0].price);
  });

  if (cartIsEmpty)
    return (
      <div className="pt-20 bg-slate-100 min-h-screen">
        <Empty />
      </div>
    );
  return (
    <div className="bg-slate-100 min-h-screen pb-10 md:pb-48">
      {cart.length > 0 && (
        <div className="">
          <CartFlexed>
            <CartContentArea>
              <div className="">
                <h4 className="text-lg md:text-xl">
                  Shopping Cart {`(${cart.length} items)`}
                </h4>
                <div className="flex justify-end text-sm">
                  <p>PRICE</p>
                </div>

                {carts.map((cart) => (
                  <CartIndividual cart={cart} key={cart.id} />
                ))}
              </div>
            </CartContentArea>
            <CartAside>
              <div className="">
                <p className="text-md">
                  Subtotal {`(${cart.length} items)`} :{" "}
                  <span className="font-bold">
                    <FontAwesomeIcon icon={faNairaSign} className="text-sm" />
                    {sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </span>
                </p>
                <div className="mt-3">
                  <Link to="/cart/checkout">
                    <button className="w-full h-10 mt-3 bg-logoRed text-white font-bold rounded-3xl">
                      Proceed to checkout
                    </button>
                  </Link>
                  <Link to="/explore">
                    <button className="w-full h-10 mt-3 border border-black font-bold rounded-3xl">
                      Continue shopping
                    </button>
                  </Link>
                </div>
              </div>
            </CartAside>
          </CartFlexed>
        </div>
      )}
    </div>
  );
};

export default Cart;
